import { Flex, notification } from "antd";
import { FC } from "react";
import {
    deleteSchedulerRemoveSchedulesPoints,
    getApiError,
} from "tm-shared/api";

import { BaseModal } from "@/components/BaseModal";
import { PrimaryText } from "@/components/Typography/Styled";
import { useAppDispatch } from "@/hooks/redux";
import useAsyncAction from "@/hooks/useAsyncAction";
import {
    RouteEditorModal,
    RouteEditorModalPayloads,
} from "@/pages/SV/RouteManagement/RouteEditor/RouteEditor.types";
import { deleteSchedules } from "@/store/slices/sv";

interface DeleteScheduleModalProps {
    onClose: () => void;
    payload: RouteEditorModalPayloads[RouteEditorModal.DeleteSchedule];
    onApprove: () => Promise<void>;
}

export const DeleteScheduleModal: FC<DeleteScheduleModalProps> = ({
    onClose,
    payload,
    onApprove,
}) => {
    const dispatch = useAppDispatch();

    const { marketIds, createMode, isEmptyAfterDelete } = payload;

    const multiSelectMode = marketIds.length > 1;

    const [handleDelete, deleteLoading] = useAsyncAction(async () => {
        if (createMode) {
            dispatch(deleteSchedules(marketIds));
            onClose();
            await onApprove();

            return;
        }

        const { currentRouteId } = payload as Extract<
            typeof payload,
            { createMode: false }
        >;

        try {
            await deleteSchedulerRemoveSchedulesPoints({
                marketIds,
                routeId: currentRouteId,
            });

            await onApprove();

            onClose();
        } catch (err) {
            console.log(err);

            const { displayMessage } = getApiError(err);
            notification.error({
                message: "Не вдалося видалити торгову точку",
                description: displayMessage,
            });
        }
    });

    const getDeleteWarningText = () => {
        if (multiSelectMode && isEmptyAfterDelete) {
            return "Ви дійсно хочете видалити вибрані торгові точки з цього маршруту? Після підтвердження маршрут буде порожнім";
        }
        if (multiSelectMode) {
            return "Ви дійсно хочете видалити вибрані торгові точки з цього маршруту?";
        }
        return "Ви дійсно хочете видалити обрану торгову точку з цього маршруту?";
    };

    return (
        <BaseModal
            open
            onClose={onClose}
            confirmText="Видалити"
            confirmLoading={deleteLoading}
            onConfirm={handleDelete}
            maskClosable={!deleteLoading}
        >
            <Flex vertical gap={16}>
                <PrimaryText
                    fontSize={20}
                    fontWeight="500"
                    style={{ textAlign: "center" }}
                >
                    Видалити ТТ
                </PrimaryText>

                <PrimaryText>{getDeleteWarningText()}</PrimaryText>
            </Flex>
        </BaseModal>
    );
};
